import util from '@/utils/index'
export default {
    // 用于获取固定数据,同一条数据只会发起一次请求,请求后会缓存在store.state中
    // 注意只能在store.action中才能调用
    // 使用例子 store.loadCacheData(context, 'chargeMan', request.service.get, '/customers/chargeMan/combobox');
    // context store.action 自带参数
    // dataName 数据名称,注意 store.mutation,store.state 的命名都必须一致
    // ajax 请求数据方法
    // url 请求数据地址
    // params 请求数据参数
    // options 额外配置
    // options.mutationName mutation中处理数据的方法,默认为set
    // options.isReLoad 是否强制重载数据 默认否
    loadCacheData(context, dataName, ajax, params, options) {
        const {
            mutationName = 'set', isReLoad = false
        } = options || {};
        // //console.log('mutationName:', mutationName, 'isReLoad:', isReLoad);
        // //console.log(context);
        // 从store.state中取出对应数据
        const data = context.state[dataName];
        // 判断store.state中是否已有数据,已有数据则不做任何处理
        if (util.objectIsEmpty(data) || isReLoad) {
            ajax(params).then((res) => {
                // 通过store.mutation在store.state中存储数据
                context.commit(mutationName, {
                    name: dataName,
                    data: res.data
                });
            }).catch(() => {
                context.commit(mutationName, {
                    name: dataName,
                    data: []
                });
            });
        }
    },
    // 通过代理方法获取数据
    // getList:获取数据方法（必填）这里可以视为代理概念
    // params:参数
    // disposeItem:遍历处理单条数据的方法
    loadData(getList, params, disposeItem) {
        return new Promise((resolve, reject) => {
            // 通过代理方法获取数据
            getList(params).then(res => {
                // 如果有遍历单条数据的方法,那么遍历处理数据
                if (disposeItem) {
                    util.eachList(res.data, disposeItem)
                }
                resolve(res)
            }).catch(res => {
                reject(res)
            })
        })
    },

    // 分页获取列表数据
    // params配置说明
    // store:数据源（必填）以下配置直接配置在store中
    // store.proxy配置说明
    // pageSize:每次加载几条数据,默认为10
    // page:起始页码,默认为1
    // getList:获取数据方法（必填）这里可以视为代理概念
    // disposeItem:遍历处理单条数据的方法
    loadPage(data) {
        // 获取参数
        const {
            store
        } = data
        // 获取代理
        const proxy = store.proxy
        // 只有之前的请求完成才能继续请求数据
        // //console.log('proxy isLoading', proxy.isLoading)
        // store默认配置
        const defaultConfig = {
            // 每次加载几条数据,默认为10
            pageSize: 10,
            // 起始页码,默认为1
            page: 1,
            // 分页每页显示条数字段名称,默认为pageSize,此参数传递到服务端
            limitParam: 'pageSize',
            // 分页页码字段名称,默认为current,此参数传递到服务端
            pageParam: 'current',
            // 数据总数默认为0
            total: 0
        }
        // 读取store配置
        const {
            getList,
            disposeItem,
            // 数据总数
            total
        } = proxy
        // 读取并设置store默认配置
        // console.log(proxy)
        for (const key in defaultConfig) {
            // console.log(key, proxy[key], !util.isEmpty(proxy[key]))
            if (!util.isEmpty(proxy[key])) {
                proxy[key] = defaultConfig[key]
            }
        }
        // 读取参数
        let params = proxy.params || {}
        // 设置分页参数
        params[proxy.limitParam] = proxy.pageSize
        params[proxy.pageParam] = proxy.page
        // 获取当前页码
        const page = proxy.page
        // 如果存在默认参数
        if (proxy.defaultParams) {
            // 浅拷贝数据
            params = Object.assign({}, proxy.defaultParams, params)
        }
        // console.log(store.isLoading);
        // 如果正在请求数据，停止请求
        if (store.isLoading) {
            return
        }
        // 表示当前正在请求数据,用于外部逻辑处理
        store.isLoading = true;
        // console.log(proxy, params)
        // 请求第一页数据时有遮罩，限制用户交互
        // 请求后续数据时无遮罩，以免手指向上滚动时点到遮罩会导致整个界面上移抖动
        params.isNomask = page != 1;
        if (page === 1) {
            // 如果页码为1,先清空数据，保证滚动条在顶部
            store.data = []
        }
        if (page !== 1 && store.data.length >= total) {
            // 如果不是加载第一页,那么说明现在是上拉加载更多
            // 如果store的数据大于或者等于数据总数,说明没有更多数据了,无须请求服务端数据
            this.loadEnd(store);
        } else {
            // 通过代理方法获取数据
            this.loadData(getList, params, disposeItem).then(res => {
                const resData = res.data
                if (page === 1) {
                    // 如果页码为1,那么是首次请求数据或者下拉刷新
                    store.data = resData
                    // 获取数据总数
                    // 如果后端没有返回数据总数，默认为当前请求的数据总数
                    proxy.total = res.total || resData.length
                    if (store.isReLoad) {
                        store.isReLoad = false
                    }
                } else {
                    // 如果页码不为1,追加数据
                    store.data.push(...resData)
                }
                this.loadEnd(store);
            }).catch(res => {
                // console.log('isError')
                this.loadEnd(store, true);
            })
        }
    },
    // 数据加载结束
    loadEnd(store, isError = false) {
        if (!isError) {
            // 判断是否还加载更多数据
            let isFinished = false;
            if (store.data.length >= store.proxy.total) {
                isFinished = true;
            }
            // van-list finished配置
            store.isFinished = isFinished;
            // console.log('isFinished', isFinished);
        }
        // 标识请求数据状态
        // van-list error.sync配置
        store.isError = isError;
        // 标识数据加载结束
        store.isLoading = false;
        // console.log('isLoading', store.isLoading);
        // 标识加载更多请求结束
        // van-list v-model配置
        // van-pull-refresh v-model配置
        store.isVanLoading = false;
    },
    // 加载store
    // store:数据源（必填）
    // params:参数
    load(store, params = {}) {
        store.params = params
        // 重置数据总数统计
        store.total = 0
        store.proxy.params = params
        store.proxy.page = 1
        this.loadPage({
            store: store
        })
    },

    // 重新加载store
    // store:数据源（必填）
    reLoad(store) {
        // 标识为重载数据
        store.isReLoad = true
        this.load(store, store.proxy.params)
    },

    // 加载store下一页
    // store:数据源（必填）
    loadNext(store) {
        const page = store.proxy.page
        // 如果正在加载，终止
        if (page && !store.isLoading) {
            store.proxy.page = page + 1
            this.loadPage({
                store: store
            })
        }
    }
}